@let collection = collectionSg();
@let comment = commentSg();
@let error =
  collection.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
@let isSubmitting =
  collection.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="narrow">
  <div class="atn-space-unassigned-sponsored-comment-modal">
    <atn-ds-widget title="Edit comment">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-unassigned-sponsored-comment-modal__content">
        <atn-ds-text-area
          label="Comment"
          placeholder="Enter a comment"
          [value]="comment"
          (change)="commentChangedHandler($event)"
          [styleOverrides]="{
            height: '120px',
            resize: 'vertical',
          }"
        />

        @if (error) {
          <atn-ds-notice
            [style]="DisplayStyle.Error"
            [description]="error"
          />
        }
      </div>

      <div
        class="atn-space-unassigned-sponsored-comment-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [loading]="isSubmitting"
          (click)="saveClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
